export default __webpack_public_path__ + "static/media/198.f0eac9b8.png";